<footer>
  <div class="container  is-fluid">
    <div class="area-proposta columns">
      <div class="column is-7">


        <div class="columns">
          <div class="column is-narrow">
            <div class="area-social">
              <img class="footer-social" width="265px" height="65px" src="../../../assets/img/brand/logo-montreal-clube-de-hospedagem-slogan.png" alt="Disponível na App Store">
              <div class="montreal-social has-text-right footer-montreal-social">
                <ul>
                    <li><a title="Instagram Montreal - Clube de Hospedagem" href="https://www.instagram.com/clubemontreal/" target="_blank"><i class="fab fa-instagram"></i></a></li>
                    <li><a title="Facebook Montreal - Clube de Hospedagem" href="https://www.facebook.com/ClubeMontreal/" target="_blank"><i class="fab fa-facebook-square"></i></a></li>
                    <li><a title="Youtube Montreal - Clube de Hospedagem" href="https://www.youtube.com/user/clubemontreal" target="_blank"><i class="fab fa-youtube"></i></a></li>
                    <li><a title="LinkedIn Montreal - Clube de Hospedagem" href="https://pt.linkedin.com/company/montreal-clube-de-hospedagem" target="_blank"><i class="fab fa-linkedin-in"></i></a></li>
                </ul>
              </div>
            </div>
          </div>

          <div id="footer-texto" class="column">
              <small>
                MONTREsdfsdfsdsfAL - HOTÉIS VIAGENS E TURISMO S.A. <br>
                CNPJ 02.703.809/0001-05.<br>
                SMAS, Área 6580, Trecho 1, <br>
                ParkShopping Corporate Torre 1, 3° andar. <br>
                Guará, Brasília – DF, CEP 71219-900<br>
<!--                Televendas: <strong>0800 610 2200</strong>-->
            </small>
          </div>
          <div class="column footer-selo">
            <img src="../../../assets/img/selo_gptw_2023.png" height="155" width="218" class="footer-certificado" alt="Selo gptw"/>
            <img src="../../../assets/img/certificado-ra1000-desktop.png" height="124" width="253" class="footer-certificado reclame" alt="Premiu Reclame Aqui 2021"/>
          </div>
        </div>
      </div>
      <div id="baixar-aplicativo" class="column is-5">
        <div class="baixe-app">
          <h4>Baixe o Aplicativo da Montreal</h4>
          <p>Acompanhe, gerencie suas diárias e aproveite os <br> benefícios da Montreal Viagens direto no seu celular.</p>
          <div class="baixe-app-buttons">
            <a target="_blank" href="https://play.google.com/store/apps/details?id=br.com.clube.montreal.institucional">
              <img width="173px" src="../../../assets/img/montreal-google-play.png" alt="Disponível no Google Play">
            </a>
            <a target="_blank" href="https://apps.apple.com/br/app/clube-montreal/id1513435651">
              <img width="173px" src="../../../assets/img/montreal-app-store.png" alt="Disponível na App Store">
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="!production" class="column ambiente" style="">
    <p>Ambiente de {{ambient}} - Versão: {{version}}</p>
  </div>

</footer>
